import { List, Record } from "immutable";

export type SessionFinishedEventType = {
  sessionId: string | undefined;
  sessionType: string | undefined;
  courseId: string | undefined;
  sectionIds: List<string>;
  contentIds: List<string>;
  // (may be empty - only populated if specific content has been chosen to be studied. Generally sessions will just be related to one sectionId),
  modulesStudied: number;
  modulesTested: number;
  modulesCorrect: number;
  modulesIncorrect: number;
  modulesGaveUp: number;
  averageScore: number | null;
  sessionScore: number | null;
  timeStarted: string | null;
  timeFinished?: string | null;
  startingProficiency: number | null;
  endingProficiency?: number | null;
  startingCourseProficiency: number | null;
  endingCourseProficiency?: number | null;
  endingCourseScore?: number | null;
  completed: boolean;
  smartLearningActive?: boolean;
  topSmartLearningSuggestionRank?: number;
  topSmartLearningSuggestionReason?: string;
  signedOut: boolean | undefined;
  wrongModuleIds: List<string>;
  totalModulesStudyTime: number;
};

const defaultValues: SessionFinishedEventType = {
  sessionId: undefined,
  sessionType: undefined,
  courseId: undefined,
  sectionIds: List(),
  contentIds: List(),
  modulesStudied: 0,
  modulesTested: 0,
  modulesCorrect: 0,
  modulesIncorrect: 0,
  modulesGaveUp: 0,
  averageScore: null,
  sessionScore: null,
  timeStarted: null,
  timeFinished: null,
  startingProficiency: null,
  endingProficiency: null,
  startingCourseProficiency: null,
  endingCourseProficiency: null,
  endingCourseScore: null,
  completed: false,
  smartLearningActive: undefined,
  topSmartLearningSuggestionRank: undefined,
  topSmartLearningSuggestionReason: undefined,
  signedOut: undefined,
  wrongModuleIds: List(),
  totalModulesStudyTime: 0
};

export default class SessionFinishedEvent extends Record(defaultValues) {}
